import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { BusinessTypeOutputDTO } from './businessTypeDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class BusinessTypeServices {
  async getByAll(): Promise<BusinessTypeOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-type/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const businessTypeServices = new BusinessTypeServices()
